import { Visibility, VisibilityOff } from "@mui/icons-material"
import { Button, Typography } from "@mui/material"
import Grid from "@mui/material/Unstable_Grid2/Grid2"
import { useContext, useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"

import OneInput from "../../Components/OneInput/OneInput"
import { UserContext } from "../../Providers/UserContext/UserContex"
import { buttonStyle, GridSx, inputStyle, SxOneForm, TypographySx } from "./SxLoginPage"

const LoginPage = () => {
    const Navigate = useNavigate()

    const [loginData, setLoginData] = useState({
        username: "",
        password: ""
    })

    const [showPassword, setShowPassword] = useState(false)

    const { login } = useContext(UserContext)

    useEffect(() => {
        let storage = sessionStorage.getItem('o_mo_user')
        if (!storage) {
            sessionStorage.setItem('o_mo_user', JSON.stringify({}))
        }
    }, [])

    const handleChange = (event) => {
        setLoginData({ ...loginData, [event.target.name]: event.target.value })
    }

    const handleSubmit = async (event) => {
        event.preventDefault()
        const loginResponse = await login(loginData)
        if (loginResponse) {
            Navigate("/")
        }
    }

    const handleShowPassword = () => {
        setShowPassword(!showPassword)
    }

    return (
        <Grid xs={12} sx={GridSx}>
            <Grid xs={12} container style={SxOneForm}>
                <form
                    onSubmit={handleSubmit}
                    style={{
                        width: '100%',
                        height: '100%',
                        boxSizing: 'border-box',
                        padding: '25px',
                        alignContent: 'center'
                    }}
                >
                    <Grid
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'space-around',
                            height: '100%',
                            gap: '15px'
                        }}
                    >

                        <Grid xs={12}>
                            <Typography fontSize={16} mb={0.5} sx={TypographySx} >
                                Usuário:
                            </Typography>
                            <OneInput
                                newSx={inputStyle}
                                autoFocus
                                name="username"
                                onChange={handleChange}
                                placeholder="Digite seu usuário"
                            />
                        </Grid>

                        <Grid xs={12}>
                            <Typography fontSize={16} mb={0.5} sx={TypographySx}>
                                Senha:
                            </Typography>
                            <OneInput
                                newSx={inputStyle}
                                name="password"
                                onChange={handleChange}
                                type={showPassword ? "text" : "password"}
                                EndIcon={showPassword ? Visibility : VisibilityOff}
                                IconCallback={handleShowPassword}
                                placeholder="Digite sua senha"
                            />
                        </Grid>

                        <Button
                            type="submit"
                            variant="contained"
                            sx={buttonStyle}
                        >
                            Login
                        </Button>
                    </Grid>
                </form>
            </Grid>
        </Grid>
    )
}

export default LoginPage
